import { requst } from '../config'

// 日历上数据
export const getWasteCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/disposal/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getWasteDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getWasteByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/disposal/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getWasteByIdApi = id => {
    const url = `/monitor/disposal/${id}`
    return requst.get(url)
}

// 获取标准处理数据
export const getStandardDataApi = id => {
    const url = `/monitor/waste/standard/list?wasteDisposalId=${id}`
    return requst.get(url)
}

// 获取危险处理数据
export const getHazardousDataApi = id => {
    const url = `/monitor/waste/hazardous/list?wasteDisposalId=${id}`
    return requst.get(url)
}

// 提交废物处理 总结
export const postWasteCommentApi = commentData => {
    const url = `/monitor/disposal`
    return requst.post(url, { ...commentData })
}

// 修改废物处理 总结
export const putWasteCommentApi = (commentData, id) => {
    const url = `/monitor/disposal`
    return requst.put(url, { ...commentData, id })
}

// 提交标准处理
export const postStandardDataApi = (standardData, id) => {
    const url = `/monitor/waste/standard/addOrUpdateBatch/${id}`
    return requst.post(url, standardData)
}

// 提交危险处理
export const postHazardousDataApi = (hazardousParams, id) => {
    const url = `/monitor/waste/hazardous/addOrUpdateBatch/${id}`
    return requst.post(url, hazardousParams)
}
